import * as React from "react"

export default function ArrowRightIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10.5 10.833v-.5H3.833v-.666H10.5V4.54L15.96 10l-5.46 5.46v-4.627z"
        fill={props.fill}
        stroke={props.fill}
      />
    </svg>
  )
}
